import { render, staticRenderFns } from "./imprimir.vue?vue&type=template&id=4543b16c&scoped=true&"
import script from "./imprimir.vue?vue&type=script&lang=js&"
export * from "./imprimir.vue?vue&type=script&lang=js&"
import style0 from "./imprimir.vue?vue&type=style&index=0&id=4543b16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543b16c",
  null
  
)

export default component.exports